import { combineReducers } from '@ngrx/store';

import { isLoadingHomeReducer as isLoadingHome } from './is-loading-home.reducer';
import { isLoadingHistoryReducer as isLoadingHistory } from '@home/store/reducers/ux/is-loading-history.reducer';

export const UiHomeRootReducer = combineReducers({
  isLoadingHome,
  isLoadingHistory
});
